__webpack_require__.p = "/wp-content/themes/vetta_theme/dist/";